module.exports = __webpack_public_path__ + "img/tripadvisor.82f60a30.png";